import adminService from "../admin/index.js"

export const consumptionVerificationApi = {
  getList(params) {
    return adminService.get("/admin/consumption-verifications", { params })
  },
  getDetail(id) {
    return adminService.get(`/admin/consumption-verifications/${id}`)
  },
  verify(id, reviewerId) {
    return adminService.put(`/admin/consumption-verifications/${id}/verify`, { reviewerId })
  },
  reject(id, reviewerId, reason) {
    return adminService.put(`/admin/consumption-verifications/${id}/reject`, { reviewerId, reason })
  },
  getStatistics() {
    return adminService.get("/admin/consumption-verifications/statistics/overview")
  }
}
